import { useState, useEffect } from 'react';

/**
 * Custom hook to track scroll position and detect when scrolled past a threshold
 *
 * @param {number} threshold - The scroll position threshold in pixels (default: 0)
 * @returns {Object} Object containing scrollY position and isScrolled boolean
 *
 * @example
 * const { scrollY, isScrolled } = useScrollPosition(50);
 * // isScrolled will be true when scrollY > 50
 */
export const useScrollPosition = (threshold = 0) => {
  const [scrollY, setScrollY] = useState(0);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      setScrollY(currentScrollY);
      setIsScrolled(currentScrollY > threshold);
    };

    // Set initial values
    handleScroll();

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [threshold]);

  return { scrollY, isScrolled };
};
